import { Component, OnInit, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { Iaddress } from 'my-lib-sanfelici/my-lib-sanfelici';



@Component({
  selector: 'app-address-details-view',
  templateUrl: './address-details-view.component.html',
  styleUrls: ['./address-details-view.component.css']
})
export class AddressDetailsViewComponent implements OnInit {
@Input() address: Observable<Iaddress>;
  constructor() { }

  ngOnInit() {
  }

}
